import { useQuery } from "@tanstack/react-query";
import { toast } from "../../components/toast/toast";
import API from "../const";
import { QueryNames } from "./queryNames";

interface ValidateTokenParams {
    token: string;
    refetchInterval?: number;
    enabled?: boolean;
}

export function useValidateToken({ token, refetchInterval, enabled }: ValidateTokenParams) {
    const { data } = useQuery({ queryKey: [QueryNames.validateToken, token], queryFn: () => {
            if (!token) {
                return false;
            }
            return fetch(`${API.VALIDATE_TOKEN}?t=Bearer ${token}`).then(async (res) => {
                if (res.status === 200) {
                    return true;
                } else {
                    if (res.status === 401) {
                        // Unauthorized
                        toast.dismiss();
                        const { message } = await res.json();
                        // toast.error(message ? message : "Session Expired");
                    }
                    return false;
                }
            });
        }, refetchInterval, enabled, refetchOnWindowFocus: false });
    return { data };
}
